module.exports = __webpack_public_path__ + "assets/img/securitiesSolutions-usa.b8c2eee7.png";